import { useCallback, useEffect, useState } from 'react';

/**
 * Which section is showing, kept in the address.
 *
 * In the URL rather than in component state so a refresh, a bookmark and the
 * back button all work. A dashboard that forgets where you were is one people
 * keep having to find their place in again.
 */
export function useHashRoute(): { route: string; navigate: (id: string) => void } {
  const read = (): string => window.location.hash.replace(/^#\/?/, '');

  const [route, setRoute] = useState(read);

  useEffect(() => {
    const onChange = (): void => setRoute(read());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  const navigate = useCallback((id: string) => {
    window.location.hash = `#/${id}`;
  }, []);

  return { route, navigate };
}
